import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';

export const Dropdown = ({ label, options, value, onChange, placeholder = "Select option", className, error }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <div className={cn("w-full", className)} ref={dropdownRef}>
      {label && (
        <label className="block text-label-md text-brand-black/70 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <button
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          className={cn(
            "w-full px-4 py-3 bg-white border border-brand-black/15 text-body-md text-left flex items-center justify-between transition-all duration-300 focus:outline-none focus:border-brand-cobalt focus:ring-1 focus:ring-brand-cobalt rounded",
            error && "border-red-500 focus:border-red-500 focus:ring-red-500"
          )}
        >
          <span className={cn(
            selectedOption ? "text-brand-black" : "text-brand-black/40"
          )}>
            {selectedOption ? selectedOption.label : placeholder}
          </span>
          <ChevronDown
            className={cn(
              "w-4 h-4 text-brand-cobalt/50 transition-transform duration-300",
              isOpen && "rotate-180"
            )}
          />
        </button>

        {isOpen && (
          <div
            className="absolute z-50 w-full mt-1 bg-white border border-brand-black/10 shadow-luxury-lg animate-fade-in-down rounded dropdown-scroll"
            style={{
              maxHeight: '280px',
              overflowY: 'scroll'
            }}
          >
            {options.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                }}
                className={cn(
                  "w-full px-4 py-3 text-body-md text-left text-brand-black/70 hover:bg-brand-cobalt/10 hover:text-brand-cobalt transition-colors",
                  value === option.value && "bg-brand-cobalt/10 text-brand-cobalt"
                )}
              >
                {option.label}
              </button>
            ))}
          </div>
        )}
      </div>
      {error && (
        <p className="mt-1 text-body-sm text-red-500">{error}</p>
      )}
    </div>
  );
};

Dropdown.displayName = "Dropdown";
